import React from 'react';
import { NotificationService } from 'ui-components/services/notification-service';

class DefaultNotificationServiceClass {
  displayNotification(notification) {
    const notificationConfig = {
      title: notification.Title,
      content: (
        // oxlint-disable-next-line react/no-danger
        <div dangerouslySetInnerHTML={{ __html: notification.Message }} />
      ),
      dontHide: true,
    };

    switch (notification.Type) {
      case 0:
        notificationConfig.notificationType = 'success';
        break;
      case 1:
        notificationConfig.notificationType = 'error';
        break;
      default:
        notificationConfig.notificationType = 'primary';
    }

    NotificationService.showNotification(notificationConfig);
  }
}

export const DefaultNotificationService = new DefaultNotificationServiceClass();
